import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconChartBarPopular.c.svg?react';

export const IconChartBarPopular = withIconWrapper(ReactComponent);
